import React from "react";
import { Container } from "reactstrap";
import Logo from './../../assets/img/logo.png';

export default function Index() {

  return (
    <>
      <Container>
        <div style={{
          textAlign: 'center'
        }}>
          <img alt="..." src={Logo} style={{
            width: '200px',
            height: '200px',
            margin: 'auto'
          }}/>
          <p>Ha expirado el tiempo del catalogo, si desea seguir visualizando nuestros producto solicite otro acceso.</p>
        </div>
      </Container>
    </>
  )
}


